import { render, staticRenderFns } from "./CloseCaseArgsForm.vue?vue&type=template&id=1a2bdb72&scoped=true&"
import script from "./CloseCaseArgsForm.vue?vue&type=script&lang=ts&"
export * from "./CloseCaseArgsForm.vue?vue&type=script&lang=ts&"
import style0 from "./CloseCaseArgsForm.vue?vue&type=style&index=0&id=1a2bdb72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2bdb72",
  null
  
)

export default component.exports